import { createAction, props } from '@ngrx/store';
import { AppStateFailure } from '@symphony-solo/shared/common-state/src';
import { LocationResponse } from '../models';

export enum LocationActionTypes {
  AuthenticateLocation = '[Location] AuthenticateLocation',
  AuthenticateLocationSuccess = '[Location] AuthenticateLocationSuccess',
  AuthenticateLocationError = '[Location] AuthenticateLocationError',
  ReAuthenticateLocation = '[Location] ReAuthenticateLocation',
  LocationBarcodeScanned = '[Location] LocationBarcodeScanned',
  ClearLocation = '[Location] ClearLocation',
}

export const authenticateLocationAction = createAction(LocationActionTypes.AuthenticateLocation, props<{ locationGuid: string }>());
export const authenticateLocationSuccessAction = createAction(
  LocationActionTypes.AuthenticateLocationSuccess,
  props<{ locationResponse: LocationResponse; locationGuid: string }>()
);
export const authenticateLocationErrorAction = createAction(
  LocationActionTypes.AuthenticateLocationError,
  props<{ failures: AppStateFailure }>()
);
export const reAuthenticateLocationAction = createAction(LocationActionTypes.ReAuthenticateLocation);
export const locationBarcodeScannedAction = createAction(LocationActionTypes.LocationBarcodeScanned, props<{ barcode: string }>());
export const clearLocationAction = createAction(LocationActionTypes.ClearLocation);
